var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-box"},[_c('div',{staticClass:"box-cover"},[_c('h3',{class:{
      typeA: _vm.type === 'orange',
      typeB: _vm.type === 'green',
      typeC: _vm.type === 'C', //blue
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('img',{attrs:{"src":(_vm.rootUrl + "/img/" + _vm.imgpath),"alt":_vm.name}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }